import { useCallback } from 'react';
import { useCheckIsExistFavouriteStationByStationCode } from 'entities/stations';

import { useGetFilteredStationCodes } from 'entities/stations';
import { useGetStationByCode } from 'store/features/stations';

import { MAX_RESULT_SEARCH_ITEMS } from '../constants';
import { MIN_SEARCH_LENGT } from 'common/constants';

export const useLoadFavouriteStations = () => {
  const checkIsExistFavouriteStationByStationCode = useCheckIsExistFavouriteStationByStationCode();
  const getFilteredStationCodes = useGetFilteredStationCodes();
  const getStationByCode = useGetStationByCode();

  const loadFavouriteStations = useCallback(async (stationCode: string) => {
    try {
      const changedStationCode = stationCode.trim().replaceAll(' ', '');
      if (changedStationCode.length >= MIN_SEARCH_LENGT) {
        const stationCodes = await getFilteredStationCodes({ stationCode: changedStationCode });
        const filteredStationCodes = stationCodes.filter(item => !checkIsExistFavouriteStationByStationCode(item));
        return filteredStationCodes
          .filter(item => !!getStationByCode(item))
          .slice(0, MAX_RESULT_SEARCH_ITEMS)
          .map(item => ({
            key: item,
            value: item
          }));
      }

      return [];
    } catch (e) {
      console.error(e);
    }
  }, [
    checkIsExistFavouriteStationByStationCode,
    getFilteredStationCodes,
    getStationByCode
  ]);

  return loadFavouriteStations;
};
